export default {
  code: 'AR',
  areaCode: '54'
}
